<div class="sp-ml-20 sp-mt-20">
  <gh-indicator [(ghValue)]="indicators.loading" [ghMessage]="'loading' | localize"></gh-indicator>
</div>

<div class="sp-px-64 sp-pb-64" id="manage-reflections" *ngIf="!indicators.loading">
  <p class="text-color-gray-9 fs-16px">{{ "manage_check_ins_description" | localize : { teamName: team.name } }}</p>

  <div class="sp-mt-24 fs-16px bold" [uiAlign]="'middle'" ui-row>
    {{ "manage_check_ins_enable_team_check_ins" | localize }}
    <ui-toggle class="sp-ml-12" [key]="'reflections'" [ngModel]="checkInSettings.reflectionsEnabled" [uiType]="'toggle'" (ngModelChange)="onToggleCheckIns($event)"></ui-toggle>
  </div>

  <div class="sp-mt-12" *ngIf="checkInSettings.reflectionsEnabled">
    <ui-tabset [uiAnimated]="false">
      <ui-tab [uiTitle]="'settings' | localize" uiClosable>
        <ui-alert
          class="sp-mb-16"
          *ngIf="isCheckInFormEmptyAlertEnabled"
          [uiMessage]="'check_ins_empty_form_alert_message' | localize"
          [uiDescription]="'check_ins_empty_form_alert_description' | localize"
          uiType="error"></ui-alert>

        <manage-reflection-questions
          [formGroup]="formGroup"
          [isMoodEnabled]="checkInTemplate.moodsEnabled"
          [isNotesEnabled]="checkInTemplate.notesEnabled"
          (questionDelete)="deleteQuestion($event)"
          (questionUpdate)="updateQuestion($event)"
          (editModeUpdate)="updateEditMode($event)"
          (questionEditModeEnable)="enableQuestionEditMode($event)"
          (questionsEditModeDisable)="disableQuestionsEditMode()"
          (moodStatusToggle)="onToggleCheckInMood($event)"
          (notesStatusToggle)="onToggleCheckInNote($event)">
        </manage-reflection-questions>
        <div class="sp-mt-12" [formGroup]="formGroup" ui-row>
          <div *ngIf="showQuestionInput" [uiXs]="24" ui-col>
            <div ui-row uiAlign="middle">
              <div [uiXs]="24" ui-col>
                <label class="fs-12px fw-400" for="new-question-input">{{ "manage_reflections_new_question" | localize }}</label>
              </div>
              <div [uiXs]="22" ui-col>
                <ui-form-item ui-row>
                  <ui-form-control class="new-question" ui-col>
                    <input
                      class="new-question-input"
                      [(ngModel)]="newQuestionTitle"
                      [ngModelOptions]="{ standalone: true }"
                      [placeholder]="'manage_check_ins_question_placeholder' | localize"
                      [maxlength]="questionMaxLength"
                      [autofocus]
                      (keyup)="updateCounter()"
                      (keyup.enter)="addCustomQuestion()"
                      ui-input
                      type="text" />
                  </ui-form-control>
                </ui-form-item>
              </div>
              <div [uiXs]="2" ui-col>
                <ui-form-item uiJustify="center" ui-row>
                  <ui-form-control ui-col>
                    <button class="cancel-question-button" (click)="toggleCustomQuestion()" ui-button uiType="link">
                      <i class="fs-16px text-color-gray-9" ui-icon uiType="trash-bin"></i>
                    </button>
                  </ui-form-control>
                </ui-form-item>
              </div>
            </div>
            <div class="sp-mt-4" ui-row>
              <div [uiXs]="12" ui-col>
                <div class="fs-10px text-color-gray-9">{{ "manage_reflections_press_enter_to_save" | localize }}</div>
              </div>
              <div class="fs-12px text-color-gray-9 character-counter" [uiXs]="10" ui-col>{{ questionLength }}/{{ questionMaxLength }}</div>
            </div>
          </div>
          <div class="create-question" *ngIf="!showQuestionInput && !isEditModeEnabled" [uiXs]="24" ui-col>
            <button class="text-color-primary-8 hov-cursor-p create-question-button" (click)="toggleCustomQuestion()" ui-button uiShape="round" uiType="link">
              <i class="sp-mr-8 fs-18px text-color-primary-8" ui-icon uiType="plus"></i>
              {{ "manage_reflections_create_question" | localize }}
            </button>
          </div>
        </div>
      </ui-tab>

      <ui-tab [uiTitle]="'manage_reflections_schedule' | localize" uiClosable>
        <manage-reflection-schedule></manage-reflection-schedule>
      </ui-tab>
    </ui-tabset>
  </div>
</div>
